export default __webpack_public_path__ + "static/media/scheduling.9fb0ae32.jpg";